/* eslint-disable no-param-reassign */
import scDK from './sdk/main';
import ScLoan from './sdk/las';

(function (window: Window) {
  window.scDK = scDK;
  window.ScLoan = ScLoan;
})(window);
